module.exports = __webpack_public_path__ + "img/ea.d61c3d24.svg";